module.exports = __webpack_public_path__ + "img/overview-new.17209ffb.svg";